<template>
  <QForm
    @submit="$emit('save')"
    @reset="$emit('cancel')"
    class="column no-wrap"
  >
    <div class="row q-py-sm q-px-md relative-position">
      <SAIIconBtn
        @click="$emit('close')"
        icon="eva-arrow-back-outline"
        size="12px"
      />
      <p class="absolute-center">{{ title }}</p>
    </div>

    <SAITabsHeader>
      <div class="q-py-md q-px-lg">
        <div class="row">
          <SAIAvatar />
          <div class="column col-grow text-white q-pl-md justify-center">
            <span class="text-title" v-if="userName">{{ userName }}</span>
            <span class="text-primary-light" v-if="companyName">
              {{ companyName }}
            </span>
          </div>
          <div v-if="!editable && !hideEditableButton">
            <SAIIconBtn
              color="white"
              icon="eva-edit-outline"
              size="12px"
              @click="$emit('update:editable', true)"
            />
          </div>
        </div>
      </div>
    </SAITabsHeader>

    <div class="q-px-md">
      <div
        v-for="field in fields"
        :key="field.key"
        class="column q-pa-md bdr-b-grey-4 no-wrap"
      >
        <div class="row">
          <QIcon
            size="18px"
            v-if="field.icon"
            :name="field.icon"
            color="grey-9"
            class="q-mr-sm"
          />
          <p v-if="field.label" class="text-grey-6 text-body">
            {{ field.label }}
          </p>
        </div>
        <div
          v-for="(value, index) in field.values"
          :key="index"
          class="full-width q-mt-xs"
        >
          <div class="row full-width" v-if="!editable">
            <p class="col col-grow">{{ value.hint }}{{ value.value || '-' }}</p>
            <div class="row items-center" v-if="value.verified">
              <QIcon
                color="positive"
                name="eva-checkmark-square-2"
                size="16px"
              />
              <span class="q-ml-xs text-positive">Verified</span>
            </div>
          </div>
          <div v-else-if="value.locked">
            <div class="row">
              <p class="col col-grow">
                {{ value.hint }}{{ value.value || '-' }}
              </p>
              <div class="row items-center" v-if="value.verified">
                <QIcon color="grey-6" name="eva-lock-outline" size="16px" />
                <span class="q-ml-xs text-grey-6">Locked</span>
              </div>
            </div>
            <SAIMessage variant="info" class="q-my-sm">
              {{ value.locked }}
            </SAIMessage>
          </div>
          <div class="editable" v-else>
            <SAIInput
              v-if="!value.locked"
              :value="value.value"
              v-bind="value.props"
              :disable="disable || value.disabled"
              hide-bottom-space
              lazy-rules
              @input="$emit('update:input', { key: value.key, value: $event })"
              :rules="[(val) => value.validation(val) || 'Error']"
            />
          </div>
        </div>
      </div>
    </div>
    <QSpace />
    <div class="row justify-center q-pa-lg q-gutter-x-sm" v-if="editable">
      <SAIBtn
        :disable="disable"
        label="Cancel"
        outline
        padding="12px xl"
        color="grey-6"
        type="reset"
      />
      <SAIBtn
        :disable="disable"
        :loading="saving"
        outline
        padding="12px xl"
        label="Save"
        type="submit"
      />
    </div>
  </QForm>
</template>

<script>
import { QIcon, QSpace, QForm } from 'quasar';
import { themes } from '../../../utils/themes';

export default {
  name: 'SAIUserProfile',
  props: {
    /**
     * Refer to documentation in get-user-profile-fields.js
     */
    fields: {
      type: Array,
      default: () => []
    },
    hideEditableButton: Boolean,
    editable: Boolean,
    userName: String,
    companyName: String,
    title: {
      type: String,
      default: 'Your Profile'
    },
    theme: {
      type: String,
      default: themes.novated.value
    },
    saving: Boolean,
    disable: Boolean
  },
  components: {
    QIcon,
    QSpace,
    QForm,
    SAITabsHeader: () => import('../sai-tabs-header'),
    SAIAvatar: () => import('../../atom/sai-avatar'),
    SAIIconBtn: () => import('../../atom/sai-icon-btn'),
    SAIInput: () => import('../../atom/sai-input'),
    SAIMessage: () => import('../../molecule/sai-message'),
    SAIBtn: () => import('../../atom/sai-btn')
  }
};
</script>
